import { Container, Divider, Typography } from '@mui/material'
import React from 'react'

export default function InternalBackend(props) {


    return (
        <Container sx={{paddingBlock:2}}>
            <Typography variant='h3'>How the Frontend Works</Typography>
            <Divider></Divider>
            <br />
            Frontend <br />
            The Backend for the Blitz app is build using Flask, a Python web framework. <br />
            We use an ORM called SQLAlchemy to interact with the database. The database is a PostgreSQL database. <br />
            The database is hosted on Vercel, as that where the backend used to be hosted. <br />

            The backend is designed loosely following REST principles. Using resource URIs to get and modify object is prefered but it doesn't always happen <br />
            All data is transmitted in JSON format. URI queries can be used for filtering and sorting data. <br />
            The backend is designed to be stateless. This means that the backend does not store any session data. We use JWT to identify user requests. <br />

            The backend is hosted on DigitalOcean. DigitalOcen deploys when commits are pushed to the 'production' branch. <br />
            We don't push to the production branch directly. We push to 'main' and when tests are passed, Github pushes to production. <br />
            Test are ran using Github Actions. <br />

            We run 3 different services on DigitalOcean. It's all built from the same codebase, and we set a different module on the DigitalOcean deploy <br />
            1) The main Blitz backend <br />
            2) The processing server backend <br />
            3) The 3rd party API backend <br />

            The main Blitz backend is the main backend for the app. It handles all requests from the frontend. <br />
            The processing server backend is used to process data. It handles all the scheduled tasks and background jobs. <br />
            The 3rd party API backend is used to offer separate API endpoints for 3rd party API calls. <br />

            The different services are defined by factories in the ./app/factories directory. <br />
            Theres a base_app factory that contains shared initialization code. <br /> 
            Factory creation can be chained together and that feature is used to tests the 3 services. at once <br />

            While the factories are defined included in the ./app/factories directory, the starting point for the apps are in ./api directory <br />

            To use the database we use the SQLAlchemy ORM. The database is defined in the ./app/models directory. <br />
            SQLAlchemy entity definitions work as follows: <br />
            Entities are Python classes that inherit from the SQLAlchemy base class. <br />
            Columns are defined as class attributes. <br />
            Relationships are defined as class attributes. <br />
            Relationships are defined like this: <br />
            other = relationship('EntityName', back_populates='entity_name', uselist=False, lazy='joined', ondelete='CASCADE', onupdate='CASCADE') <br />
            The back_populates parameter is used to load this instance in the other entity<br />
            The uselist=False means that the relationship is a one to one relationship. <br />
            The lazy='joined' means that the relationship is loaded when the entity is loaded. <br />
            The ondelete='CASCADE' means that when the entity is deleted, the relationship is also deleted. <br />
            The onupdate='CASCADE' means that when the entity primary key is updated, the relationship is also updated. <br />
            The other option for lazy is 'select', which means that the relationship is loaded when it is accessed. <br />

            Columns are defined like this: <br />
            id = Column(Integer, primary_key=True) <br />
            name = Column(String(255), nullable=False) <br />
            
            The Column function is used to define the column. <br />
            The first parameter is the type of the column. <br />
            Other parameters are used to define the column. <br />
            The primary_key parameter is used to define the primary key. <br />
            The nullable parameter is used to define if the column can be null. <br />
            The default parameter is used to define the default value of the column. <br />
            The unique parameter is used to define if the column is unique. <br />

            Scheduled tasks are defined in the ./app/jobs directory. We use the Flask APS Scheduler to run scheduled tasks. <br />
            Tasks are functions that are decorated with the @scheduler decorator. <br />
            @scheduler.task('cron', id='delete_old_google_requests', minute='*/15', misfire_grace_time=900, max_instances=1) <br />
            The task is defined with a cron expression. <br />
            To use backend functionality in the job we wrap the code in this: <br />
            with scheduler.app.app_context(): <br />

            Routes are defined in the ./app <br />
            We add folders for each module. <br />
            Routes and endpoints are defined using Flask Blueprints. <br />
            Every module has an index.py file that creates the blueprint and a routes.py file that defines the functions. <br />
            Heres an example of an index.py file: <br />
            from flask import Blueprint <br />

            bp = Blueprint('files', __name__) <br />

            from app.files import routes <br />

            Heres an example of a routes.py file: <br />
            from flask import request, jsonify <br />
            from app.files import bp <br />
            @bp.route('/api/files', methods=['GET']) <br />
            def get_files(): <br />
            files = get_all_files() <br />
            return jsonify(files) <br />

            The services that will use this route will import the index.py file and register the blueprint on the factory <br />

            Utility CLI scripts that are ran from the command line are defined in the ./app/cli directory. <br />
            The scripts are defined using the Flask CLI. <br />
            The scripts are defined using the @cli.command decorator. <br />
            The scripts are defined like this: <br />
            @cli.command('create_db') <br />

            Tests are written using the Pytest library. <br />
            Tests are defined in the .app/tests directory. <br />
            Pytest finds and runs every module that starts with test_ or ends with _test.py <br />

            Fixtures are used to create test data. <br />
            Fixtures are defined using the @pytest.fixture decorator. <br />
            

            Various batch file are included to execute a local version of the app. The batch files are located in the root of the project.<br />
            <br />
            We use Python verion python-3.12.6 <br />
            run_set_envs.bat is a helper script that loads the correct .env variables. <br />
            run_blitz_back.bat creates or loads a python venv and starts the app locally <br />
            run_blitz_back_cli.bat just loads the venv and lets you run CLI commands <br />
            run_blitz_back_job.bat loads the venv and starts the job scheduler locally<br />
            run_tests.bat loads the venv and runs the tests <br />


        </Container>
    )
}
